import axios from 'axios'
import qs from 'qs'
import get from './get'
let apiUrl = ''
if (process.env.NODE_ENV === 'development') {
    apiUrl = 'http://mnhome.m.dangdang.com'
}
const http = axios.create({
    withCredentials: true,
    transformRequest: [function(data) {
        var mergeData = Object.assign({}, data, get());
        data = qs.stringify(mergeData);
        return data;
    }],
    transformResponse: [function(data) {

        var data = JSON.parse(data)
            //这里提前处理返回的数据
        if (data.errorCode == 0) {
            if (!data.errorMsg && !data.errorMessage) {
                data.errorMsg = '成功'
            }
        } else {
            if (!data.errorMsg && !data.errorMessage) {
                data.errorMsg = '失败'
            }
        }
        return data;
    }],
    headers: {
        post: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With':'XMLHttpRequest'
        }
    },
    baseURL: apiUrl
});

export { http }


// WEBPACK FOOTER //
// ./src/common/js/ajax.js